var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66536 4.83342H8.9987V3.50008C8.9987 1.66008 7.50536 0.166748 5.66536 0.166748C3.82536 0.166748 2.33203 1.66008 2.33203 3.50008V4.83342H1.66536C0.932031 4.83342 0.332031 5.43341 0.332031 6.16675V12.8334C0.332031 13.5667 0.932031 14.1667 1.66536 14.1667H9.66536C10.3987 14.1667 10.9987 13.5667 10.9987 12.8334V6.16675C10.9987 5.43341 10.3987 4.83342 9.66536 4.83342ZM5.66536 10.8334C4.93203 10.8334 4.33203 10.2334 4.33203 9.50008C4.33203 8.76675 4.93203 8.16675 5.66536 8.16675C6.3987 8.16675 6.9987 8.76675 6.9987 9.50008C6.9987 10.2334 6.3987 10.8334 5.66536 10.8334ZM3.66536 4.83342V3.50008C3.66536 2.39341 4.5587 1.50008 5.66536 1.50008C6.77203 1.50008 7.66536 2.39341 7.66536 3.50008V4.83342H3.66536Z",
    fill: "#404A51"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.afad863aab69af5d85efbc4e4fc68392.svg";
export { ForwardRef as ReactComponent };